const urls = {
    DOWNLOAD_EMPTY: "tank-management/empty-tank-excel-template",
    DOWNLOAD_FILLED: "tank-management/filled-tank-excel-template",
    LOAD_TANKS:"tank-management/tank",
    LOAD_DETAILS: "tank-management/tank-calibration",
    UPLOAD_EXCEL: "tank-management/insert-from-excel",
    DELETE_TANK: "tank-management/tank",
    GET_TANK_BY_CODE: "tank-management/tank-by-code/",
    UPLOAD_EXCEL_VOLUMETRIC_DATA: "tank-management/tank-volumetric-data-import-from-excel"
}

import genericService from '../genericService';

export default {
    async getTanks(body, callback){
        await genericService.get(urls.LOAD_TANKS, body).then(callback);
    },
    async getDetails(body, callback){
        await genericService.get(urls.LOAD_DETAILS, body).then(callback);
    },
    async downloadEmptyExcel(body, callback){
        await genericService.dowloadFile(urls.DOWNLOAD_EMPTY, body).then(callback);
    },
    async downloadFilledExcel(body, callback){
        await genericService.dowloadFile(urls.DOWNLOAD_FILLED, body).then(callback);
    },
    async uploadExcel(formData, callback){
        await genericService.uploadFile(urls.UPLOAD_EXCEL, formData).then(callback);
    },
    async deleteTank(id, callback){
        await genericService.delete(urls.DELETE_TANK, id).then(callback);
    },
    async getTankByCode(code, callback){
        await genericService.get(urls.GET_TANK_BY_CODE + code, {}).then(callback);
    },
    async uploadExcelVolumetricData(formData, callback){
        await genericService.uploadFile(urls.UPLOAD_EXCEL_VOLUMETRIC_DATA, formData).then(callback);
    },
}